import Link from "next/link";
import {JSX} from "react";

import styles from "@@/styles/components/ui/NewButton.module.scss";
import {exo2Bold, exo2Regular} from "@@/utils/fonts";

interface IButtonProps {
	href: string
	title: string
	bgColor?: string
	textColor?: string
	className?: string
	linkClassName?: string;
	textClassName?: string;
}

export default function Button(props: IButtonProps): JSX.Element {
	const { href, title, bgColor, textColor, className, linkClassName, textClassName } = props;

	return (
		<Link href={href} className={`${styles.link} ${linkClassName}`}>
			<div className={`${styles.container} ${className}`} style={{ background: bgColor, }}>
				<p className={`${exo2Regular.className} ${textClassName}`} style={{ color: textColor, }}>{title}</p>
			</div>
		</Link>
	);
}
